import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  entriesPerPage: 10,
};

const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setEntriesPerPage(state, action) {
      state.entriesPerPage = action.payload;
    },
  },
});

export const { setCurrentPage, setEntriesPerPage } = paginationSlice.actions;

export default paginationSlice.reducer;
